<script>
  import {whichDisplay} from './stores';
  import { am_sideBySideComparisonStore } from './stores_adaptation_measures.js';
  // the <Header> component:
  // - displays title text from a passed in prop
  // - provides container for an Esri JSAPI Search Widget

  // a prop passed in from parent
  export let title;
</script>

<header class="row space-between">
  <div class="header">
    <img src="images/logo.png" width="150" alt="Logo of Boston Water and Sewer Commission" />
    <span class="title">{title}</span>
  </div>

  <div class="header">
    <calcite-button 
      on:click="{() => whichDisplay.set('noaction')}"
      class={$whichDisplay === "noaction" ? "calcite-mode-light": "calcite-mode-dark"}
      scale="s">
    <span class="bigTitle">
      Baseline
    </span> 
    </calcite-button>
    <span>&nbsp;</span>
    <calcite-button
      on:click="{() => {
        am_sideBySideComparisonStore.set(false);
        whichDisplay.set('adaptationmeasures');
      }}"
      scale="s"
      class={$whichDisplay === "adaptationmeasures" ? "calcite-mode-light": "calcite-mode-dark"}
      style="margin-right: 8px">
    <span class="bigTitle">Adaptation Measures</span>
  </calcite-button>

  </div>

  <div class="search-widget-box" id="searchWidgetBox">
    <div class="search-widget-container" id="searchWidget"></div>
  </div>
</header>

<style>
  .calcite-mode-light {
    --calcite-ui-brand: #032a5c !important;
  }
  
  .space-between {
    justify-content: space-between;
  }

  .header {
    /* margin: 0.5rem; */
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    margin: 0.5rem 8px 0.5rem 16px;
  }

  .header .title {
    margin-left: 1rem;
  }

  .search-widget-container {
    align-self: center;
    /* margin-right: 0.5rem; */
  }

  .search-widget-box {
    margin: 10px 16px 10px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .bigTitle {
    font-size: 1.2rem;
  }
</style>
